import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby"
import _ from "lodash";
import { Row, Col, Accordion } from "react-bootstrap";
import "./FooterPopularSearches.scss"
import ResidentialDetailPopularSearch from "../DynamicPopularSearch/ResidentialSearch/ResidentialDetailPopularSearch";
import ResidentialPopularSearch from "../DynamicPopularSearch/ResidentialSearch/ResidentialPopularSearch";
import CommercialPopularSearch from "../DynamicPopularSearch/CommercialSearch/CommercialPopularSearch";
import AreaGuideDetails from "../DynamicPopularSearch/ResidentialSearch/AreaGuideDetails";
// import NewHomesPopularSearch from "../DynamicPopularSearch/NewHomesSearch/NewHomesPopularSearch";
// import NewHomesDetailsSearch from "../DynamicPopularSearch/NewHomesSearch/NewHomesDetailsSearch";
import CTALink from "@components/elements/CTALink"

const FooterPopularSearches = (props) => {
  const [allData, setAllData] = useState([]);
  const data = useStaticQuery(graphql`
    query {
      allStrapiPopularSearch {
        edges {
          node {
            title
            new_column {
              add_new_link {
                title
                custom_link
                link {
                  slug
                  target_window
                  link_type
                  strapi_parent {
                    slug
                  }
                }
              }
            }
            pages {
              strapi_id
            }
          }
        }
      }
    }
    `);
  const popularSearchLinks = data.allStrapiPopularSearch?.edges;
  useEffect(() => {
    var filtered = _.filter(popularSearchLinks, function (o) { return o.node.title === props.popularSearch });
    setAllData(filtered)
  }, [popularSearchLinks])
  return (
    <Accordion className={`popular-searches-accordion ${props.popularSearch ? '' : 'empty-search'}`}>
      {allData.length > 0 &&
        <Accordion.Item eventKey="0">
          <Accordion.Header>Popular Searches</Accordion.Header>
          <Accordion.Body>
            {allData && allData.map((item, index) => (
              <Row>
                {item?.node.new_column?.map((col, i) => {
                  return (
                    <Col xl={3}>
                      <ul className="list-unstyled popular-searches-list">
                        {col?.add_new_link?.map((main, i) => (
                          <li>
                            {main.link ? <CTALink
                              cta={{
                                cta_label: main.title,
                                menu: main.link,
                                custom_link: main.custom_link
                              }} /> :
                              <a href={main.custom_link}>{main.title}</a>}
                          </li>
                        ))}
                      </ul>
                    </Col>
                  )
                })}
              </Row>
            ))}
          </Accordion.Body>
        </Accordion.Item>
      }
      {props.popularSearch === "residential" &&
        <Accordion.Item eventKey="1">
          <Accordion.Header>Popular Searches</Accordion.Header>
          <Accordion.Body>
            <ResidentialPopularSearch popularSearchObject={props.popularSearchObject} />
          </Accordion.Body>
        </Accordion.Item>
      }
      {props.popularSearch === "commercial" &&
        <Accordion.Item eventKey="1">
          <Accordion.Header>Popular Searches</Accordion.Header>
          <Accordion.Body>
            <CommercialPopularSearch popularSearchObject={props.popularSearchObject} />
          </Accordion.Body>
        </Accordion.Item>
      }
      {props.popularSearch === "residential-detail" &&
        <Accordion.Item eventKey="2">
          <Accordion.Header>Popular Searches</Accordion.Header>
          <Accordion.Body>
            <ResidentialDetailPopularSearch popularSearchDetailsObject={props.popularSearchDetailsObject} />
          </Accordion.Body>
        </Accordion.Item>
      }
      {props.popularSearch === "areaguide-details" &&
        <Accordion.Item eventKey="3">
          <Accordion.Header>Popular Searches</Accordion.Header>
          <Accordion.Body>
            <AreaGuideDetails popularSearchDetailsObject={props.popularSearchDetailsObject} />
          </Accordion.Body>
        </Accordion.Item>
      }
      {props.popularSearch === "office-details" &&
        <Accordion.Item eventKey="4">
          <Accordion.Header>Popular Searches</Accordion.Header>
          <Accordion.Body>
            <AreaGuideDetails popularSearchDetailsObject={props.popularSearchDetailsObject} />
          </Accordion.Body>
        </Accordion.Item>
      }
      {/* {props.popularSearch === "residential-detail" &&
              <ResidentialDetailPopularSearch popularSearchDetailsObject={props.popularSearchDetailsObject} />
          }
          {props.popularSearch === "new-homes" &&
              <NewHomesPopularSearch popularSearchObject={props.popularSearchObject} />
          }
          {props.popularSearch === "new-homes-detail" &&
              <NewHomesDetailsSearch popularSearchDetailsObject={props.popularSearchDetailsObject} />
          }*/}
    </Accordion>
  )
}

export default FooterPopularSearches